import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ChartWrapperModule } from './graphs/chart-wrapper.module';
import { ReportOutputContainerLandscapeDirective } from './report-output-container/report-output-container-landscape.directive';
import { ReportOutputContainerPortraitDirective } from './report-output-container/report-output-container-portrait.directive';
import { ReportOutputContainerComponent } from './report-output-container/report-output-container.component';
import { ReportOutputDateComponent } from './report-output-date/report-output-date.component';
import { ReportOutputHeaderBarComponent } from './report-output-header-bar/report-output-header-bar.component';
import { ReportOutputHeaderComponent } from './report-output-header/report-output-header.component';
import { ReportParameterListComponent } from './report-parameter-list/report-parameter-list.component';

@NgModule({
   declarations: [
      ReportOutputHeaderBarComponent,
      ReportOutputHeaderComponent,
      ReportOutputDateComponent,
      ReportParameterListComponent,
      ReportOutputContainerComponent,
      ReportOutputContainerLandscapeDirective,
      ReportOutputContainerPortraitDirective,
   ],
   exports: [
      ReportOutputHeaderBarComponent,
      ReportOutputHeaderComponent,
      ReportOutputDateComponent,
      ReportParameterListComponent,
      ReportOutputContainerComponent,
      ReportOutputContainerLandscapeDirective,
      ReportOutputContainerPortraitDirective,
   ],
   imports: [CommonModule, MatIconModule, ChartWrapperModule],
})
export class SharedReportOutputModule {}
